import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';

import './Filter.css';
import infoIcon from '../../resources/img/info-icon.png';
import AddCategoryOrTag from './AddCategoryOrTag';
import config from '../../constant/config';

export class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditMode: false,
      categories: [],
      tags: [],
      editingCategoryId: null,
      editingTagId: null,
      selectedCategoryId: null,
      showModal: false,
      noTagCategories:[],
      duplicate_cat:null,
      errorMessage:false,
    };
  }

  async componentDidMount() {
    try {
      const res = await fetch(
        `${config.apiURL}/hub/${this.props.hubId}/getFilterData`,
        {
          credentials: 'include',
          method: 'GET',
          headers: { 'content-type': 'application/json' }
        }
      );
      if (res.status === 200) {
        const data = await res.json();
        this.setState({
          categories: data.categories,
          tags: data.tags,
          selectedCategoryId: data.categories[0].id
        });
      } else {
        console.log('Error fetching filter data');
      }
    } catch (err) {
      console.log('Error fetching filter data', err);
    }
  }

  toggleEditMode = () => {
    this.setState((prev) => ({ isEditMode: !prev.isEditMode }));
  };

  handleCategoryClick = (id) => {
    if (this.state.isEditMode) {
      this.setState({ editingCategoryId: id , selectedCategoryId: id });
    } else {
      this.setState({ selectedCategoryId: id });
    }
  };

  handleTagClick = (id) => {
    if (this.state.isEditMode) {
      this.setState({ editingTagId: id });
    }
  };
  handleCategoryNameChange = (e, id) => {
    const newName = e.target.value;
    this.setState((prev) => ({
      categories: prev.categories.map((cat) =>
        cat.id === id ? { ...cat, categoryName: newName } : cat
      )
    }));
    this.setState({ selectedCategoryId: id });
  };

  handleTagNameChange = (e, id) => {
    const newName = e.target.value;
    this.setState((prev) => ({
      tags: prev.tags.map((tag) =>
        tag.id === id ? { ...tag, tagName: newName } : tag
      )
    }));
    this.setState({ editingTagId: id });
  };

  deleteCategory = (id) => {
    this.setState((prev) => ({
      categories: prev.categories.filter((cat) => cat.id !== id),
      tags: prev.tags.filter((tag) => tag.categoryid !== id)
    }));
  };

  deleteTag = (id) => {
    this.setState((prev) => ({
      tags: prev.tags.filter((tag) => tag.id !== id)
    }));
  };

  addCategoryOrTag(index) {
    this.setState({
      showModal: true,
      modalContent: (
        <AddCategoryOrTag
          closeModal={() => this.closeModal()}
          listOfCategoriesOrTags={(index, list) =>
            this.listOfCategoriesOrTags(index, list)
          }
          index={index}
        />
      )
    });
  }
  async listOfCategoriesOrTags(index, list) {

    let trimmed_list = list.split(',').map(item => item.trim());
    let list_ = [...new Set(trimmed_list)];

    if (index === 1 && list_.length !== 0) {
      const res = list_.filter(
        (cat) => !this.state.categories.some((c) => c.categoryName === cat)
      );


      const response = await fetch(
        `${config.apiURL}/hub/${this.props.hubId}/addCategories`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            newCategories: res
          })
        }
      );
      if (response.status === 200) {
        const raw = await response.json();

        const newCategories = raw.map((item) => ({
          id: item.id,
          categoryName: item.categoryName
        }));

        let  duplicatesInNewList = trimmed_list.filter((item, index) => {
  return trimmed_list.indexOf(item) !== index;
});
     let x =  list_.filter(
        (cat) => this.state.categories.some((c) => c.categoryName === cat)
      );

  let duplicate_cat =[...new Set([...duplicatesInNewList,...x])]    
     

        this.setState({
          categories: [...this.state.categories, ...newCategories],
          showModal: false
        });
         if(duplicate_cat){
        this.setState({
          errorMessage : true,
          duplicate_cat
        })
      
         const timer = setTimeout(() => {
      this.setState({
          errorMessage: false
        })
    }, 3000);
  }

      }
    } else if (index === 2 && list_.length !== 0) {
      const res = list_.filter(
        (tagName) => !this.state.tags.some((t) => t.tagName === tagName)
      );

      const new_tags = res.map((tagName) => ({
        tagName,
        categoryid: this.state.selectedCategoryId
      }));

      const response = await fetch(
        `${config.apiURL}/hub/${this.props.hubId}/addTags`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            newTags: new_tags
          })
        }
      );
      if (response.status === 200) {
        const raw = await response.json();

        const newTags = raw.map((item) => ({
          id: item.id,
          categoryid: item.categoryid,
          tagName: item.tagName
        }));

        this.setState({
          tags: [...this.state.tags, ...newTags],
          showModal: false
        });
      }
    }
  }

  closeModal = () => {
    this.setState({
      showModal: false
    });
  };

  async onSave(){

const noTagCategories = this.state.categories.filter(cat => {
  const hasTag = this.state.tags.some(tag => tag.categoryid === cat.id);
  return !hasTag;
});

if(noTagCategories.length !== 0 ){

this.setState({noTagCategories});
}
else{
    const res = await fetch(`${config.apiURL}/hub/${this.props.hubId}/updateFilterData`,{
          method: 'PUT',
          credentials: 'include',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            tags: this.state.tags,
            categories:this.state.categories
          })
        })

        if(res.status === 200){
          this.setState((prev) => ({showModal: true,
      modalContent: (
        <div style={{padding: '40px', display:'flex',justifyContent:'center', flexDirection:'column',gap:'20px', alignItems:'center', fontSize:'18px' }}>
          <div >Your changes have been successfully saved. </div>
          <div>Remember to update your modules accordingly with the new or updated tags you have created.</div>
          <div>If you want to proceed and make further changes, click the button below.</div>
          <div><Button className = 'orange-button' onClick={()=>{
            this.closeModal()
            this.props.changeTab(0)
            }}>Proceed</Button></div>
        </div>
      ),
       isEditMode: !prev.isEditMode, noTagCategories:[]}));
        }
      }
  }

  render() {
    const {
      categories,
      tags,
      isEditMode,
      editingCategoryId,
      editingTagId,
      selectedCategoryId
    } = this.state;

    return (
      <div className="filter-main-container">
        <div className="heading-container">
          <h1 className="main-heading">Filter Settings</h1>
          {!isEditMode && (
            <Button className="orange-button" onClick={this.toggleEditMode}>
              Edit
            </Button>
          )}
        </div>
        <div className="sub-category-container">
          <div className="sub-heading-container">
            <h2 className="sub-heading">Categories</h2>
            <div className="info-container">
              <img
                className="info-icon"
                src={infoIcon}
                alt="help icon"
                style={{ height: '18px', width: '18px', marginTop: '30px' }}
              />
              <span
                className="hover-text"
                style={{ top: '20px', left: '30px' }}
              >
                You need at least one category to use filters.
              </span>
            </div>
            {isEditMode && (
              <div>
                <Button
                  className="orange-box-button"
                  onClick={() => this.addCategoryOrTag(1)}
                >
                  Add Category +
                </Button>
              </div>
            )}
          </div>
          <div style={{ fontSize: '20px' }}>
            A category is a way to group tags together under a relevant heading.
            For example, you might have categories for age groups, different
            levels of fitness, or several activities. Click on an existing
            category to view its associated tags.
          </div>
          <div>
            {categories.map((cat) => (
              <span key={cat.id} style={{ marginRight: 20 }}>
                {!isEditMode ? (
                  <button
                    onClick={() => this.handleCategoryClick(cat.id)}
                    className={
                      selectedCategoryId === cat.id
                        ? 'selected-button'
                        : 'display-button'
                    }
                  >
                    {cat.categoryName}
                  </button>
                ) : editingCategoryId === cat.id && isEditMode && selectedCategoryId === cat.id? (
                  <>
                    <input
                      className="input-categories"
                      value={cat.categoryName}
                      onChange={(e) => this.handleCategoryNameChange(e, cat.id)}
                      onFocus={(e) => this.handleCategoryNameChange(e, cat.id)}
                      onBlur={() => this.setState({ editingCategoryId: null })}
                    />
                    <button
                      className={
                        selectedCategoryId === cat.id
                          ? 'selected-x-button'
                          : 'display-x-button'
                      }
                      onClick={() => this.deleteCategory(cat.id)}
                    >
                      X
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => this.handleCategoryClick(cat.id)}
                      className={
                        selectedCategoryId === cat.id
                          ? 'selected-edit-button'
                          : 'display-edit-button'
                      }
                    >
                      {cat.categoryName}
                    </button>
                    <button
                      className={
                        selectedCategoryId === cat.id
                          ? 'selected-x-button'
                          : 'display-x-button'
                      }
                      onClick={() => this.deleteCategory(cat.id)}
                    >
                      X
                    </button>
                  </>
                )}
              </span>
            ))}
          </div>
          {
            (this.state.errorMessage && this.state.duplicate_cat != null) && <div>
              Removed duplicate categories:{
                this.state.duplicate_cat.map(
                  (cat) => (cat)
                )
              }
              </div>
          }
        </div>
        <div className="sub-category-container">
          <div className="sub-heading-container">
            <h2 className="sub-heading">Tags</h2>
            <div className="info-container">
              <img
                className="info-icon"
                src={infoIcon}
                alt="help icon"
                style={{ height: '18px', width: '18px', marginTop: '30px' }}
              />
              <span
                className="hover-text"
                style={{ top: '20px', left: '30px' }}
              >
                You need at least one tag to use filters.
              </span>
            </div>
            {isEditMode && (
              <div>
                <Button
                  className="orange-box-button"
                  onClick={() => this.addCategoryOrTag(2)}
                >
                  Add Tag +
                </Button>
              </div>
            )}
          </div>
          <div style={{ fontSize: '20px' }}>
            A tag is associated with its relevant category. For example, if you
            have a category titled “Age Group” you might have a few tags named
            “Early Years”, “Children”, or “Young Adults”.
          </div>
          <div>
            {tags
              .filter((tag) => tag.categoryid === selectedCategoryId)
              .map((tag) => (
                <span key={tag.id} style={{ marginRight: 10 }}>
                  {!isEditMode ? (
                    <button
                      className="selected-button"
                      onClick={() => this.handleTagClick(tag.id)}
                    >
                      {tag.tagName}
                    </button>
                  ) : editingTagId === tag.id && isEditMode ? (
                    <>
                      <input
                        className="input-categories"
                        value={tag.tagName}
                        onChange={(e) => this.handleTagNameChange(e, tag.id)}
                        onFocus={(e) => this.handleTagNameChange(e, tag.id)}
                        onBlur={() => this.setState({ editingTagId: null })}
                      />
                      <button
                        className="selected-x-button"
                        onClick={() => this.deleteTag(tag.id)}
                      >
                        X
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="selected-edit-button"
                        onClick={() => this.handleTagClick(tag.id)}
                      >
                        {tag.tagName}
                      </button>
                      <button
                        className="selected-x-button"
                        onClick={() => this.deleteTag(tag.id)}
                      >
                        X
                      </button>
                    </>
                  )}
                </span>
              ))}
          </div>
        </div>
       {this.state.noTagCategories.length > 0 && (
  <div style={{fontSize:'14px', color:'rgb(169, 68, 66)'}}>
    Please add at least one tag for each of these categories:
    <div style={{display: 'flex', gap:'1em'}}>
    {this.state.noTagCategories.map(cat => (
      <p key={cat.categoryName} style={{fontSize:'14px', color:'rgb(169, 68, 66)' }}>{cat.categoryName}</p>
    ))}
    </div>
  </div>
)}
        {isEditMode && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className="orange-button" onClick={()=>{this.onSave()}}>
              Save
            </Button>
          </div>
        )}
        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton />
          {this.state.modalContent}
        </Modal>
      </div>
    );
  }
}

export default Filter;
